import {ReportTable} from '../../../components/Table/types';
import {Table as TableComponent} from '../../../components/Table';
import React from 'react';
import useTableData from './useTableData';

const Table = () => {
  const table: ReportTable = useTableData();

  return <TableComponent table={table} />;
};

export default Table;
